module.exports = __webpack_public_path__ + "static/Muli-Bold.557f369c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/muli/Muli-Bold.ttf
// module id = 330
// module chunks = 114276838955818